import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllMPMetalSheetTables = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.MPMETAL_SHEET}`, {
        params: { page, size, search: searchString },
    });

    return response.data;
};